import React, {useState, useRef} from "react";

export default function ProjectList() {
  return (<div className="map__results-inner">
    <div className="projects">
      <div className="project project--inline" data-project="198" data-list-image="https://res.cloudinary.com/dgbcm65u4/image/upload/ar_16:9,c_fill,e_sharpen,g_auto,h_111,w_140/yoczp2z3rh0gdygvroyz" data-hightlight-image="https://res.cloudinary.com/dgbcm65u4/image/upload/ar_16:9,c_fill,e_sharpen,g_auto,h_205,w_594/yoczp2z3rh0gdygvroyz">
        <div className="project__image"></div>
        <div className="project__content">
          <div className="project__content-head">
            <div className="project__content-head-inner">
              <h4 className="project__title">
                <a href="/projects/198">Biomass Boiler Building</a>
              </h4>
              <span className="project__location">
                <span>Quincy, CA</span>
              </span>
            </div>
            <div className="project__content-head-aside">
              <span>Mass Timber 2,000 sq ft</span>
            </div>
          </div>
          <div className="project__content-entry">
            <p>This is the first full Cross-Laminated Timber (CLT) building in the state of California. It couples a biomass boiler with a small-scale power generator, resulting in an innova..</p>
          </div>
        </div>
      </div>
    </div>
  </div>)
}
